<template>
<!-- 고객센터 안내 팝업 -->
    <div role="dialog" class="mobile-toast-popup" :class="{active : visibleNoticeCsToastPopup}">
        <div class="opacity-bg" @click.prevent="closeNoticeCsToastPopup('mobileClose')"></div>
        
        <!-- 모바일 태블릿은 토스트팝업, PC는 레이어팝업 형태 -->
        <div class="toast-layout pc-popup">
            <p class="toast-name">고객센터 안내</p>
            
            <div class="popup-compo-body">
                <p>빠른 아이디 확인을 위해 필요한 정보를 미리 준비해주세요.</p>
                <div class="compo-bd-box">
                    <p><strong>회원계정 정보</strong></p>
                    <p>이름/휴대폰번호/회원계정의 사업자등록정보</p>
                </div>
                <div class="btns">
                    <a href="tel:1588-5639" class="btn-l btn-p-l">1588-5639 연결</a>
                    <button type="button" @click="copyToEmail('cs3@tscientific.co.kr', '이메일 주소가 복사되었습니다.')" class="btn-l btn-p">이메일 복사</button>
                </div>
            </div>
            
            <!-- <p class="toast-name">고객센터 연말 단축근무 안내</p>
            <div class="popup-compo-body">
                <p>연말 단축근무로 인한 휴무 안내해드립니다.<br>2022년 <span class="color-primary">12월 30일 오후 14시 ~ 1월 2일 오전 9시</span>까지 휴무입니다.</p>
                <p>기타 문의 사항은 이메일 (<a href="mailto:cs3@tscientific.co.kr">cs3@tscientific.co.kr</a>) 문의를 남겨주시면 순차적으로 회신드리겠습니다.</p>
                <p>즐거운 연말 보내시기 바랍니다.</p>
                
                <div class="btns">
                    <button type="button" @click="closeNoticeCsToastPopup('desktopClose')" class="btn-l btn-p">닫기</button>
                </div>
            </div> -->
            
            <!-- PC 팝업 닫기 아이콘 -->
            <button type="button" @click.prevent="closeNoticeCsToastPopup('desktopClose')" class="position-absolute i-x tablet-none" aria-label="안내창 닫기">
                <IconClose />
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { copyToClipBoard } from '@/util';

export default {
    components: {
        IconClose: () => import('@/components/svg-icon/IconClose.vue'), // PC형 팝업닫기 아이콘
    },

    data() {
        return {
            // visibleNoticeCsToastPopup : false,
        }
    },

    computed: {
		...mapState({
            visibleNoticeCsToastPopup: state => state.modalStore.modalsObj.visibleNoticeCsToastPopup,
        }),
	},

    mounted() {
        this.controlBodyScroll();
    },

    watch: {
        visibleNoticeCsToastPopup(){
            this.controlBodyScroll();
        } 
    },

    methods: {
        // 쿠키 팝업 활성화 여부
        activePopup(){
            if(document.cookie.indexOf("todayCookieYescon=done") < 0){    // indexOf -1이면 쿠키없음
                this.showNoticeCsToastPopup();
            }else{
                this.closeNoticeCsToastPopup();
            }
        },

        // 쿠키 적용
        handleCookieClick() {
            this.closeNoticeCsToastPopup();

            let todayDate = new Date();
            todayDate.setDate(todayDate.getDate() + 1);
            document.cookie = "todayCookieYescon=" + escape('done') + "; path=/; expires=" + todayDate.toGMTString() + ";"
        },

        closeNoticeCsToastPopup() {
            this.$store.commit('modalStore/setVisibleNoticeCsToastPopup', false);
        },

        showNoticeCsToastPopup() {
            this.$store.commit('modalStore/setVisibleNoticeCsToastPopup', true);
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleNoticeCsToastPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },

        // 이메일 주소 복사
        copyToEmail(email, message){
            copyToClipBoard(email, message);
        },
    },
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/yescoin.scss';

</style>